'use strict';

var ajax = require('../ajax'),
	formPrepare = require('../pages/checkout/formPrepare'),
	util = require('../util'),
	loqate = require('../loqate'),
	reCaptcha = require('int_recaptcha/recaptcha');

// remove required and error flags, hide fields
function resetFields($contactUsFields) {
	$contactUsFields.each(function(i, field) {
		$(field).removeClass('required').rules('remove');
		if ($(field).hasClass('error')) {
			$('#contactUs').validate().element($(field));
		}
		var $label = $(field).parents('.form-row').find('label span');
		if ($label.text().includes('*')) {
			var newLabelValue = $label.text().replace('*', '');
			$label.text(newLabelValue);
		}
		$(field).parents('.form-row').addClass('visually-hidden');
		$('.enter-manually').addClass('visually-hidden');
	});
}

// modify the visibility and required state of fields mentioned in the array of fields for display
function updateFieldsState($contactUsFields, fieldsToShow) {
	for (var fieldToShow of fieldsToShow) {
		fieldToShow = fieldToShow.trim();
		var isRequired = fieldToShow.indexOf('-req') > -1;
		var name = isRequired ? fieldToShow.slice(0, fieldToShow.indexOf('-req')) : fieldToShow;
		for (var contactField of $contactUsFields) {
			if ($(contactField).attr('name').includes(name.toLowerCase())) {
				$(contactField).parents('.form-row').removeClass('visually-hidden');
				if (isRequired) {
					$(contactField).addClass('required');
					var $label = $(contactField).parents('.form-row').find('label span');
					$label.text($label.text() + '*');
				}
				// display addressy field if address1 is shown
				if ($(contactField).is('[name*="address1"]')) {
					$('.form-row.addressy').removeClass('visually-hidden');
					$('.enter-manually').removeClass('visually-hidden');
					if (isRequired) {
						var $label = $('.addressFinder').parents('.form-row').find('label span');
						$label.text($label.text() + '*');
					}
				}
			}
		}
	}
	formPrepare.init({
		formSelector: '#contactUs',
		continueSelector: '#sendBtn',
		replaceInvalidInput: true,
		keyup: true,
		autofillValidate: true
	});
}

exports.init = function () {
	var $contactUs = $('#contactUs'),
		$subTopicSelect = $contactUs.find('[name$="_reason"]'),
		$contactUsFields = $contactUs.find(':input:not([name*="reason"], [name*="businessarea"])');
		if ($('.select-topic').prop('selectedIndex') > 0) {
			$contactUs.find('.disable-form').hide();
			reasonChangedCallback($('.select-topic'));
		}

	formPrepare.init({
		formSelector: '#contactUs',
		continueSelector: '#sendBtn',
		replaceInvalidInput: true,
		keyup: false,
		autofillValidate: true
	});

	loqate.init($contactUs);

	ajax.load({
		url: Urls.getBillingAddress,
		callback: function (response) {
			var responseObj = JSON.parse(response);
			var address = responseObj.address;
			if (!$.isEmptyObject(responseObj.address)) {
				$contactUsFields.filter('[name*="email"]').val(address.email);
				$contactUsFields.filter('[name*="firstname"]').val(address.firstName);
				$contactUsFields.filter('[name*="lastname"]').val(address.lastName);
				$contactUsFields.filter('[name*="country"]').val(address.countryCode).trigger('change');
				$contactUsFields.filter('[name*="address1"]').val(address.address1);
				$contactUsFields.filter('[name*="address2"]').val(address.address2);
				$contactUsFields.filter('[name*="postal"]').val(address.postalCode);
				$contactUsFields.filter('[name*="mobilephone"]').val(address.phone);
				loqate.updateAddressDescriptionWithForm($contactUs);
			}
		}
	});

	// make indentation when pressed Tab key in comment textarea
	$contactUs.on('keydown', '[name$="_comment"]', function (e) {
		if (e.which === 9) {
			e.preventDefault();
			var start = this.selectionStart;
			var end = this.selectionEnd;
			$(this).val($(this).val().substring(0, start) + "\t" + $(this).val().substring(end));
			this.selectionStart = this.selectionEnd = start + 1;
		}
	});

	//update Reasons on change
	$contactUs.on('change', '.select-topic', function () {
			reasonChangedCallback($(this));
	});
	//update FAQs and fields visibility and state
	$subTopicSelect.on('change', function () {
		var chosenOption = $(this).find(':selected'),
			relevantFAQcontentAsset = chosenOption.data('item-id');
		if (relevantFAQcontentAsset) {
			ajax.load({
				url:util.appendParamsToUrl(Urls.includeContentAsset, {cid: relevantFAQcontentAsset}),
				target:$contactUs.find('#specific-subtopic-faqs'),
				callback:function () {
					$('#subtopic-faqs-wrapper').addClass('active');
				}
			});
		} else {
			$('#subtopic-faqs-wrapper').removeClass('active');
		}
		var chosenReasonFields = chosenOption.data('form-fields');
		var areaFields = $('[name*="contactUsFields"]').val();
		if (chosenReasonFields) {
			resetFields($contactUsFields);
			var reasonFieldsArr = chosenReasonFields.split(',');
			updateFieldsState($contactUsFields, reasonFieldsArr);
		} else if (areaFields) {
			resetFields($contactUsFields);
			var areaFieldsArr = areaFields.split(',');
			updateFieldsState($contactUsFields, areaFieldsArr);
		}
	});
	//update Reasons and fields visibility and state
	function reasonChangedCallback(elm) {
		var chosenTopic = elm.val().trim();
		if (chosenTopic) {
			ajax.load({
				url: Urls.getContactUsReasons,
				data: {businessarea: chosenTopic},
				callback: function (response) {
					var responseObj = JSON.parse(response);
					$subTopicSelect.find('option').not(':first').remove();
					$subTopicSelect.append(responseObj.contactUsReasons);
					if (responseObj.contactUsFields) {
						$("input[name*='contactUsFields']").val(responseObj.contactUsFields);
					}
					resetFields($contactUsFields);
					$contactUs.find('.disable-form').hide();
					$subTopicSelect.trigger('change');
				}
			});
		} else {
			$contactUs.find('.disable-form').show();
			$('#subtopic-faqs-wrapper').removeClass('active');
		}
	}

	$contactUs.on('submit', function () {
		// clean values of filled fields if they are hidden
		$contactUsFields.each(function(i, field) {
			if ($(field).parents('.form-row').hasClass('visually-hidden') && $(field).val()) {
				$(field).val('');
			}
		});
		if (!$contactUs.valid()) {
			reCaptcha.resetRecaptchaForms();
		}
	});

	reCaptcha.initRecaptchaOnForm('#contactUs', function() {
		$contactUs.trigger('submit');
	});
};
